import {
    SURVEYS_DELETE_ITEMS,
    SURVEYS_DELETE_ITEMS_ERROR, SURVEYS_DELETE_ITEMS_SUCCESS, SURVEYS_GET_LIST,
    SURVEYS_GET_LIST_ERROR,
    SURVEYS_GET_LIST_SEARCH, SURVEYS_GET_LIST_SUCCESS,
    SURVEYS_GET_LIST_WITH_FILTER,
    SURVEYS_GET_LIST_WITH_ORDER,
    SURVEYS_SELECTED_ITEMS_CHANGE,
    SURVEYS_SAVE_ITEM_SUCCESS,
    SURVEYS_ADD_ITEM_SUCCESS
} from 'projects/redux/surveys/actions_def';

const INIT_STATE = {
    allSurveys: [],
    surveys: [],
    errors: [],
    filter: null,
    searchKeyword: '',
    orderColumn: null,
    isLoaded: false,
    isLoading: false,
    totalItems: 0,
    saving: false,
    labels: [
        { label: 'EDUCATION', color: 'secondary' },
        { label: 'NEW FRAMEWORK', color: 'primary' },
        { label: 'PERSONAL', color: 'info' },
    ],
    orderColumns: [
        { column: 'title', label: 'Title' },
        { column: 'category', label: 'Category' },
        { column: 'status', label: 'Status' },
        { column: 'label', label: 'Label' },
    ],
    categories: ['Flexbox', 'Sass', 'React'],
    selectedItems: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SURVEYS_GET_LIST:
            return {
                ...state,
                isLoaded: false,
                isLoading: true,
            };

        case SURVEYS_GET_LIST_SUCCESS:
            // console.log(action.payload)
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                allSurveysItems: action.payload,
                surveys: action.payload,
                totalItems: action.payload.length
            };

        case SURVEYS_GET_LIST_ERROR:
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                error: action.payload
            };

        case SURVEYS_GET_LIST_WITH_FILTER:
            if (action.payload.column === '' || action.payload.value === '') {
                return {
                    ...state,
                    isLoaded: false,
                    isLoading: true,
                    surveysItems: state.allSurveysItems,
                    filter: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const filteredItems = state.allSurveysItems.filter(
                (item) => item[action.payload.column] === action.payload.value
            );
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                surveysItems: filteredItems,
                filter: {
                    column: action.payload.column,
                    value: action.payload.value,
                },
            };

        case SURVEYS_GET_LIST_WITH_ORDER:
            if (action.payload === '') {
                return {
                    ...state,
                    isLoaded: false,
                    isLoading: true,
                    surveysItems: state.surveysItems,
                    orderColumn: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const sortedItems = state.surveysItems.sort((a, b) => {
                if (a[action.payload] < b[action.payload]) return -1;
                if (a[action.payload] > b[action.payload]) return 1;
                return 0;
            });
            return {
                ...state,
                isLoaded: false,
                isLoading: true,
                surveysItems: sortedItems,
                orderColumn: state.orderColumns.find(
                    (x) => x.column === action.payload
                ),
            };

        case SURVEYS_GET_LIST_SEARCH:
            if (action.payload === '') {
                return { ...state, surveysItems: state.allSurveysItems };
            }
            // eslint-disable-next-line no-case-declarations
            const keyword = action.payload.searchTerm.toLowerCase();
            // eslint-disable-next-line no-case-declarations
            console.log(keyword, state.allSurveysItems)
            // const searchItems = state.allSurveysItems.filter(
            //     (item) =>
            //         item.title.toLowerCase().indexOf(keyword) > -1 ||
            //         item.detail.toLowerCase().indexOf(keyword) > -1 ||
            //         item.status.toLowerCase().indexOf(keyword) > -1 ||
            //         item.category.toLowerCase().indexOf(keyword) > -1 ||
            //         item.label.toLowerCase().indexOf(keyword) > -1
            // );
            return {
                ...state,
                isLoaded: false,
                isLoading: true,
                // surveysItems: searchItems,
                searchKeyword: keyword,
            };

        case SURVEYS_SELECTED_ITEMS_CHANGE:
            return {
                ...state, isLoaded: false,
                isLoading: false, selectedItems: action.payload
            };

        case SURVEYS_DELETE_ITEMS:
            return {
                ...state,
                isLoaded: false,
                isLoading: true,
                saving: true
            };

        case SURVEYS_DELETE_ITEMS_SUCCESS:

            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                saving: false,
                saved: true,
                errors: [],
                allSurveysItems: state.allSurveysItems.filter(item => item.id !== action.payload.rfc_id),
                surveysItems: state.surveysItems.filter(item => item.id !== action.payload.rfc_id),
            };

        case SURVEYS_DELETE_ITEMS_ERROR:
            // console.log("Failed", action.payload)
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                saving: false,
                saved: true,
                errors: action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        case SURVEYS_SAVE_ITEM_SUCCESS:

            return {
                ...state,
                surveys: [...state.surveys, action.payload]
            };


        case SURVEYS_ADD_ITEM_SUCCESS:
            console.log("Survey added. Adding to list.")
            return {
                ...state,
                surveys: [...state.surveys, action.payload]
            };

        default:
            return { ...state };
    }
};
